import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { PureComponent } from 'react';
import { QueryPreviewTabs } from '../types.js';
import { renderTabPanelButtonId, renderTabPanelId } from '../utils/a11y.js';
import { TreeView } from './TreeView.js';
const rootProps = {
    'aria-labelledby': renderTabPanelButtonId(QueryPreviewTabs.querySubscriptions),
    id: renderTabPanelId(QueryPreviewTabs.querySubscriptions),
    role: 'tabpanel',
};
export class QueryPreviewSubscriptions extends PureComponent {
    render() {
        const { subscriptions } = this.props;
        return (_jsx(TreeView, { rootProps: rootProps, data: subscriptions, isWideLayout: this.props.isWideLayout }));
    }
}
